var _path, _circle, _circle2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSources(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 260",
    fill: "none",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M168 175 Q168 98 200 85 Q232 98 232 175 Q200 188 168 175 Z",
    stroke: "#fafcfb",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 186,
    cy: 128,
    r: 3.5,
    fill: "#fafcfb"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 214,
    cy: 128,
    r: 3.5,
    fill: "#fafcfb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M192 148 Q200 155 208 148",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 60 L145 110",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M140 107 L145 110 L138 112",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350 60 L255 110",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M260 107 L255 110 L262 112",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.7,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M60 180 L150 160",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M145 157 L150 160 L145 164",
    stroke: "#fbbf24",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M340 180 L250 160",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M255 157 L250 160 L255 164",
    stroke: "#38bdf8",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M200 30 L200 75",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M196 70 L200 75 L204 70",
    stroke: "#fafcfb",
    strokeWidth: 1.5,
    strokeOpacity: 0.6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M100 240 L165 195",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M170 192 L165 195 L170 199",
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M300 240 L235 195",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.4,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M230 192 L235 195 L230 199",
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 55,
    r: 8,
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.5
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 355,
    cy: 55,
    r: 8,
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.5
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 185,
    r: 6,
    stroke: "#fbbf24",
    strokeWidth: 1.2,
    strokeOpacity: 0.4
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 350,
    cy: 185,
    r: 6,
    stroke: "#38bdf8",
    strokeWidth: 1.2,
    strokeOpacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 22,
    r: 5,
    stroke: "#fafcfb",
    strokeWidth: 1.2,
    strokeOpacity: 0.4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 245,
    r: 5,
    stroke: "#38bdf8",
    strokeWidth: 1,
    strokeOpacity: 0.3
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 245,
    r: 5,
    stroke: "#fbbf24",
    strokeWidth: 1,
    strokeOpacity: 0.3
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 75,
    cy: 120,
    r: 1.5,
    fill: "#38bdf8",
    opacity: 0.4
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 325,
    cy: 120,
    r: 1.5,
    fill: "#fbbf24",
    opacity: 0.4
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 200,
    cy: 50,
    r: 1,
    fill: "#fafcfb",
    opacity: 0.3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSources);
export default __webpack_public_path__ + "static/media/sources.52d1bd18af1b1e351c30996c625e7567.svg";
export { ForwardRef as ReactComponent };